import React, { type ReactNode } from 'react';
import { styled as styled2 } from '@compiled/react';
// eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';
import Avatar, { AvatarItem } from '@atlaskit/avatar';
import Lozenge from '@atlaskit/lozenge';
import { token } from '@atlaskit/tokens';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { IntlShapeV2 as IntlShape } from '@atlassian/jira-intl/src/v2/types.tsx';
import type { Actor } from '../../../common/types';
import { isActorInvitedUser } from '../../../common/utils';
import messages from './messages';

type Props = {
	actor: Actor;
	intl: IntlShape;
};

export const MentionItem = (props: Props) => {
	const {
		intl: { formatMessage },
	} = props;
	return (
		<AvatarItemContainer>
			<AvatarItem
				// By default AvatarItem has themed background unless passed otherwise
				backgroundColor="transparent"
				avatar={<Avatar src={props.actor.avatarUrl || undefined} />}
				primaryText={
					<MentionPrimaryTextWrapper>
						<DisplayNameWrapper>{props.actor.displayName}</DisplayNameWrapper>
						{isActorInvitedUser(props.actor) ? (
							<InviteLozengeWrapper>
								<Lozenge appearance="new">{formatMessage(messages.invitedUser)}</Lozenge>
							</InviteLozengeWrapper>
						) : null}
					</MentionPrimaryTextWrapper>
				}
			/>
		</AvatarItemContainer>
	);
};

export default injectIntl(MentionItem);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const MentionPrimaryTextWrapper = styled2.div<{
	children?: ReactNode;
}>({
	display: 'flex',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const InviteLozengeWrapper = styled2.span<{
	children?: ReactNode;
}>({
	margin: `0 ${token('space.100', '8px')}`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const DisplayNameWrapper = styled2.span<{
	children?: ReactNode;
}>({
	textOverflow: 'ellipsis',
	overflow: 'hidden',
});
DisplayNameWrapper.displayName = 'DisplayNameWrapper';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const AvatarItemContainer = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'> *': {
		cursor: 'auto',
	},
});
